<template>
  <div class="container mb-5">
    <div class="row mb-5 my-md-5">
      <h2 class="text-center">
        {{ $t('obrigadoPeloPedido') }}
        <br>
        {{ $t('agradecemosPreferenciaEmailSeraEnviado') }}{{ email }}
        <br>
        {{ $t('seVoceTiverAlgumaDuvidaEmailPara') }}
      </h2>
      <div class="row justify-content-md-center">
        <div class="col-lg-4 text-center">
          <LoadingButton
            class="btn-primary" :loading="carregando" @click="assinarGerenciar"
          >
            <i class="bi bi-cash-coin" /> {{ $t('gerenciarAssinatura') }}
          </LoadingButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSessionFromId, getCustomerPortal } from '../stripeService';
import LoadingButton from '@/modules/core/components/LoadingButton.vue';
export default {
  components: { LoadingButton },
  props: {

    sessionId: { type: String, required: true },

  },
  data() {
    return {
      session: null,
      email: null,
      carregando: false,
    };
  },

  async beforeCreate() {
    this.session = await getSessionFromId(this.sessionId);
    this.email = this.session.customer_details.email;
    if (this.session.status === 'open') {
      this.$router.replace('/dashboards/assinar');
    }
  },
  unmounted() {
  },
  methods: {
    async assinarGerenciar() {
      this.carregando = true;
      this.customerPortalUrl = await getCustomerPortal();
      window.location.href = this.customerPortalUrl;
    },
  },
};
</script>
